const HOME_ROUTE = '/'

const DISCORD_LOGIN_CALLBACK_ROUTE = '/discord'

const GUILDS_ROUTE = '/guilds'

const EVENTS_ROUTE = '/events'

export { HOME_ROUTE, DISCORD_LOGIN_CALLBACK_ROUTE, GUILDS_ROUTE, EVENTS_ROUTE }
